import { render, staticRenderFns } from "./UnassignedAssetsTable.vue?vue&type=template&id=ddfa9862"
import script from "./UnassignedAssetsTable.vue?vue&type=script&lang=js"
export * from "./UnassignedAssetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports